import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { NaviGate } from "../../../Utility/function";

const Projectpage = () => {
    const navigate = useNavigate();
    const [search, setSearch] = useState("");

    const menuItems = [
        {
            name: "Projects",
            route: "/projects_expenses",
            icon: "bi bi-people",
            url: "assets/images/menu/document.png",
        },
        {
            name: "To-dos",
            route: "/project_todo",
            icon: "bi bi-box-seam",
            url: "assets/images/menu/quotetion.png",
        },
        // {
        //     name: "Service Expenses",
        //     route: "/service_expenses",
        //     icon: "bi bi-people",
        //     url: "assets/images/menu/document.png",
        // },
    ];

    const handleCardClick = (route) => {
        navigate(route);
    };

    return (
        <div className="my-4 mx-3 pb-5">
        <NaviGate />
            <div
                className="product-grid row d-flex justify-content-center align-items-center"
                style={{ padding: "10px 25px", minHeight: "80vh" }}>
                {menuItems
                    .filter((item) =>
                        item.name.toLowerCase().includes(search.toLowerCase())
                    )
                    .map((item, index) => (
                        <div className="col-12 col-md-4 col-lg-2 mb-2 mt-2" key={index}>
                            <div
                                className="card h-100 text-center"
                                onClick={() => handleCardClick(item.route)}
                                style={{ cursor: "pointer" }}
                            >
                                <div className="card-body">
                                    <img
                                        src={item?.url}
                                        width={"50px"}
                                        style={{ marginTop: "8px" }}
                                        alt={item.name}
                                    />
                                    <h5 className="card-title mt-3 text-small">{item.name}</h5>
                                </div>
                            </div>
                        </div>
                    ))}
            </div>
        </div>
    );
};

export default Projectpage;


